<template>
  <v-layout fill-height>
    <v-sheet width="100%" height="100%" elevation="0">
      <v-row align="center" justify="center" fill-height>
        <v-col cols="6" v-if="!$vuetify.breakpoint.xs">
          <v-img height="100vh" :src="loginImg"></v-img>
        </v-col>
        <v-col class="d-flex flex-column justify-center align-center">
          <v-card
            v-if="!message.resetPassword.success"
            max-width="380"
            width="100%"
            elevation="0"
            class="d-flex flex-column justify-center align-center py-5"
          >
            <v-img
              :src="logo"
              max-width="200"
              contain
              position="center center"
            />
            <label
              style="
                color: #19d3da !important;
                font-size: 10px;
                font-weight: bold;
              "
              >DEMAND MEETS SUPPLY</label
            >
            <v-card-title>
              <label class="title">Passwort zurücksetzen</label>
            </v-card-title>
            <span class="pb-7">
              <v-label> Gib hier dein neues Passwort ein. </v-label>
            </span>
            <v-form ref="form" @submit.prevent="submitPasswordReset">
              <v-alert type="error" text :value="!!message.resetPassword.error">
                {{ message.resetPassword.error }}
              </v-alert>
              <v-row>
                <v-col cols="12" class="d-flex flex-column">
                  <v-label>Neues Passwort</v-label>
                  <v-text-field
                    background-color="#FCFDFE"
                    dense
                    outlined
                    full-width
                    v-model="password"
                    type="password"
                    :rules="[fieldRules.length6, fieldRules.empty]"
                    required
                  ></v-text-field>
                  <v-label>Passwort bestätigen</v-label>
                  <v-text-field
                    background-color="#FCFDFE"
                    dense
                    outlined
                    full-width
                    v-model="confirmedPassword"
                    type="password"
                    :rules="[passwordConfirmationRule]"
                    required
                  ></v-text-field>
                  <v-btn
                    type="submit"
                    color="secondary"
                    class="mt-2 rounded-pill align-self-center"
                    elevation="0"
                    width="175"
                    >Passwort ändern
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
            <fly-in-message
              ref="errorMessage"
              message="Aktualisierung fehlgeschlagen: Prüfen Sie die angebene E-Mail-Adresse und die Gültigkeit des Links. Fordern Sie ggf. erneut eine Zurücksetzung des Passwords an."
              type="error"
            />
          </v-card>
          <v-card
            v-if="message.resetPassword.success"
            elevation="0"
            class="d-flex flex-column justify-center align-center pa-5"
          >
            <v-img
              :src="logo"
              max-width="200"
              contain
              position="center center"
            />
            <label
              style="
                color: #19d3da !important;
                font-size: 10px;
                font-weight: bold;
              "
              >DEMAND MEETS SUPPLY</label
            >
            <v-card-title>
              <label>Passwort erfolgreich geändert!</label>
            </v-card-title>
            <div
              class="py-4 align-sef-center"
              style="text-align: center; max-width: 335px"
            >
              <v-label max-width="335">
                Dein Passwort wurde erfolgreich geändert und du kannst dich nun mit deinen neuen Logindaten anmelden.
              </v-label>
            </div>
            <v-btn
              @click="$router.push('/login')"
              color="secondary"
              class="mt-2 rounded-pill align-self-center"
              width="110"
              elevation="0"
            >
              Zum Login
            </v-btn>
          </v-card>
        </v-col>
      </v-row>
    </v-sheet>
  </v-layout>
</template>

<script>
import fieldRules from '../utils/FieldRules'
import { mapActions, mapState } from 'vuex'
import _ from 'lodash'
import logo from '../../../assets/manushare.png'
import loginImg from '../../../assets/login.jpg'
import FlyInMessage from '../FlyInMessage.vue'

export default {
	components: { FlyInMessage },
	name: 'ResetPassword',
	data () {
		return {
			logo: logo,
			loginImg: loginImg,
			password: '',
			confirmedPassword: '',
			fieldRules: fieldRules,
			message: {
				resetPassword: {
					error: '',
					success: ''
				}
			}
		}
	},
	computed: {
		passwordConfirmationRule () {
			return () =>
				this.password === this.confirmedPassword ||
        'Passwörter stimmen nicht überein'
		}
	},
	mounted () {
		this.email = this.$route.query.email
	},
	props: {
		token: { type: String, default: '' }
	},
	methods: {
		...mapActions('auth', ['resetPassword']),
		resetMessages () {
			_.set(this.messages, 'resetPassword.success', '')
			_.set(this.messages, 'resetPassword.error', '')
		},
		submitPasswordReset () {
			this.resetMessages()
			if (this.$refs.form.validate()) {
				this.resetPassword({
					email: this.email,
					token: this.token,
					password: this.password
				})
					.then(() => {
						this.message.resetPassword.success =
              'Passwort erfolgreich aktualisiert.'
					})
					.catch(() => {
						this.$refs.errorMessage.show()
					})
			}
		}
	}
}
</script>

<style scoped>
.v-label {
  font-family: "Karla";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 16px;
  text-align: center;
  color: #667085;
}

.v-form .v-label {
  text-align: left;
  color: #303941;
}

.v-btn {
  font-family: "Karla";
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 16px;
  display: flex;
  align-items: center;
  text-align: center;
  border-radius: 19px;
  text-transform: none !important;
}

.v-text-field--outlined >>> fieldset {
  border: 1px solid #f0f1f7;
}

.v-text-field {
  border-radius: 8px;
  font-family: "Karla";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #303941;
  width: 375px;
}

.title {
  font-family: "Karla";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 33px;
  text-align: center;
  color: #303941;
}
</style>
